import {Injectable} from '@angular/core';
import {Observable, of} from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class TranslationApiService {

  /**
   * Fetches the list of available languages from the Translation API.
   *
   * @returns {Observable<string[]>} An observable that emits an array of language codes (e.g., ['en', 'fr', 'es']).
   * @memberof TranslationApiService
   */
  public getAvailableLanguages(): Observable<string[]> {
    return of(['it_IT', 'en_GB']);
  }
}
